import { createSelector } from '@reduxjs/toolkit'

// -----------------------------------------------------------------------------------------------------------APP
export const appTiles = state => state.app.tiles
export const appSearch = state => state.app.search
export const appStatus = state => state.app.status

// -----------------------------------------------------------------------------------------------------------ARTICLE
export const articleLoaded = article => state => state.article.loaded[article]
export const articleEntity = article => state => state.article.entities[article]

// -----------------------------------------------------------------------------------------------------------ARTICLES
export const articlesTotal = state => state.articles.total
export const articlesPages = state => state.articles.pages
export const articlesItem = id => state => state.articles.entities[id]
export const articlesCurrentPage = state => state.articles.currentPage
export const articlesSelectedIsLoaded = state => state.articles.loaded[articlesCurrentPage(state)]
export const articlesList = state => articlesPages(state)[articlesCurrentPage(state)]
export const selectArticlesTotalPages = createSelector(articlesTotal, total => Math.ceil(total / 5))
export const selectArticlesPages = createSelector(selectArticlesTotalPages, total => [...Array(total)].map((_, i) => i + 1))

// -----------------------------------------------------------------------------------------------------------BRANDS
export const brandsStatus = state => state.brands.status
export const brandsEntities = state => state.brands.entities

// -----------------------------------------------------------------------------------------------------------CARDS
export const cards = (url, id) => state => state.cards.products[url][id]
export const cardsLoaded = url => state => state.cards.loaded?.[url]

// -----------------------------------------------------------------------------------------------------------CART
export const cartItems = state => state.cart.items
export const cartStatus = state => state.cart.status
export const cartEntities = state => state.cart.entities

export const cartCount = id => state => state.cart.items[id] || 0
export const cartItemsArray = createSelector(cartItems, Object.keys)
export const cartEntitiesArray = createSelector(cartEntities, Object.values)

const cartKeys = state => Object.keys(cartItems(state))
export const cartItemsToLoad = createSelector(cartKeys, cartEntities, (keys, entities) => keys.filter(id => !(id in entities)))

// -----------------------------------------------------------------------------------------------------------CATALOGS
export const catalogs = state => state.catalogs.entities
export const catalogsTotal = state => state.catalogs.total
export const catalogsLoading = state => state.catalogs.loading

// -----------------------------------------------------------------------------------------------------------CERTIFICATES
export const certificatesStatus = state => state.certificates.status
export const certificates = state => state.certificates.entities
export const certificatesItem = id => state => certificates(state)[id]
export const selectCertificatesList = createSelector(certificates, Object.keys)

// -----------------------------------------------------------------------------------------------------------COMPARE
const compareItemsArr = state => state.compare.items
export const compareItem = productUrl => state => compareItemsArr(state)?.[productUrl]
export const compareItems = createSelector(compareItemsArr, Object.keys)
export const compareCount = createSelector(compareItems, items => Object.keys(items).length)


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// -----------------------------------------------------------------------------------------------------------FILTERS
export const sortBy = state => state.filters.sortBy
export const queryString = (state, url) => state.filters.queryString?.[url]
export const filteredProducts = (state, url) => state.filters.products[url]
export const filterStoredMinMax = url => state => state.filters.minmax?.[url]

const filtersEntities = state => state.filters.filters
export const filters = url => createSelector(filtersEntities, obj => obj[url])

const fltr = (state, url) => state.filters.filters[url]/////////////////////////// как это засунуть в селектор?
export const selectNormalizedFilters = createSelector(fltr, filters =>
   filters.reduce((acc, { searchGroup, products }) => {
      acc[searchGroup] = {}
      for (let [key, value] of Object.entries(products)) acc[searchGroup][key] = value
      return acc
   }, {})
)

export const filtersIsFiltering = (state, url) => state.filters.isFiltering[url] === undefined ? true : state.filters.isFiltering[url]


//////////////////////////------------------------------------- здесь (state, url) - по другому нельзя - это ОК
const products = (state, url) => state.cards.products[url]
export const filtersMinMax = createSelector(
   products,
   products => {
      const productsArr = Object.keys(products)
      if (productsArr.length === 0) return [0, 0]// guard when no products
      const priceArr = productsArr.map(id => products[id].p)
      return [Math.min(...priceArr), Math.max(...priceArr)]
   })

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// -----------------------------------------------------------------------------------------------------------FORM
export const formLoading = state => state.form.loading
export const formLoaded = state => state.form.loaded
export const formError = state => state.form.error

// -----------------------------------------------------------------------------------------------------------HOME
export const homeStatus = state => state.home.status
export const homeSlider = state => state.home.slider
export const homeAddressBar = state => state.home.addressBar
export const homePopularProducts = state => state.home.popularProducts

// -----------------------------------------------------------------------------------------------------------MENU
export const menuStatus = state => state.menu.status
export const menuLinks = state => state.menu.links
const menuTitlesByUrl = createSelector(
   menuLinks,
   links => links.reduce((acc, { url, title }) => Object.assign(acc, { [url]: title }), {})
)
export const getTitle = url => state => menuTitlesByUrl(state)[url]

// -----------------------------------------------------------------------------------------------------------MENU BURGER
export const mainMenuIsOpen = state => state.burgerMenu.main.isOpen
export const filtersMenuIsOpen = state => state.burgerMenu.filters.isOpen

// -----------------------------------------------------------------------------------------------------------ORDER
export const orderLoading = state => state.order.loading
export const orderModalIsOpen = state => state.order.modalIsOpen
export const orderPaymentIsProceeded = state => state.order.paymentIsProceeded
export const orderPaymentIsSuccessful = state => state.order.paymentIssuccessful

// -----------------------------------------------------------------------------------------------------------PRODUCTS
export const productsEntities = state => state.products.entities
export const productItem = productUrl => state => productsEntities(state)[productUrl]
export const productsLoaded = productUrl => state => state.products.entities[productUrl] || false

// -----------------------------------------------------------------------------------------------------------PROMO
export const promoStatus = type => state => state.promo[type + 'Status']
export const promoItems = type => state => state.promo[type]

// -----------------------------------------------------------------------------------------------------------REVIEWS
export const reviewsStatus = productUrl => state => state.reviews.status[productUrl] || 'init'
export const reviewsItems = productUrl => state => state.reviews.entities[productUrl]

// -----------------------------------------------------------------------------------------------------------SIMILAR
export const similarStatus = state => state.similar.status
export const similarItems = state => state.similar.entities
